import Text from "../text"
import { Container, Message } from "./styles"


interface IProps {
  texto: string,
  tamanhoFonte?: string
  textoSecundario?: string | null
}


const MensagemListaVazia: React.FC<IProps> = ({ texto, tamanhoFonte, textoSecundario }) => {
  return (
    <Container>
      <Text className="!text-[.875rem] !font-bold text-center">{texto}</Text>
      <img src="assets/empty.png" width={70} style={{ opacity: .6 }} />
      {textoSecundario && <Text className="!text-[.875rem] !font-light text-center">{textoSecundario}</Text>}
    </Container>
  )
}


export default MensagemListaVazia;